<code-verification [(verificationCode)]="verificationCode" [displaySendAgainByMail]="false" #codeVerify
    (verificationCodeChange)="onVerificationCodeChange($event)" (verificationCodeCancel)="onVerificationCodeCancel()"
    (sendAgainVerificationCode)="sendVerificationCode()" [verificationCodeDetails]="verificationCodeDetails"
    [(verificationType)]="verificationCodeDetails.verificationType" [lightTitle]="false">
</code-verification>
<div class=" gap-1 flex flex-column align-items-center">
    <div class="flex flex-row gap-1/2" >לא קבלתי קוד.  
        <a class="underline" (click)="sendVerificationCode(true)">שלח לי שוב</a>
    </div>
    <button class="w-max px-4" pButton (click)="verificationOk()" 
        [disabled]="!codeVerify?.formGroup?.valid">{{'LOGIN.VERIFICATIN_TITEL'|
        translate}}</button>
</div>